export default __webpack_public_path__ + "fonts/connect-promo-check-icon.svg";